import request from '@/utils/request'

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/material/industry/asphaltNewsList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/material/industry/asphaltNews/${id}`,
        method: 'get',
    })
}

// 价格列表
export function priceList(query) {
    return request({
        url: '/material/metatron/price/asphaltPriceList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsAsphaltPriceList`,
        method: 'get',
        params:query
    })
}

// 价格列表
export function yieldList(query) {
    return request({
        url: '/material/industry/asphaltYieldList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function yieldDetail(id) {
    return request({
        url: `/material/industry/asphaltYield/${id}`,
        method: 'get',
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/material/report/reportAsphaltList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/material/report/boardAsphaltInfo/${id}`,
        method: 'get',
    })
}

// 进出口列表
export function exitList(query) {
    return request({
        url: '/material/industry/asphaltExitList',
        method: 'get',
        params: query
    })
}

// 进出口详情
export function exitDetail(id) {
    return request({
        url: `/material/industry/asphaltExit/${id}`,
        method: 'get',
    })
}

// 利润列表
export function profitList(query) {
    return request({
        url: '/material/metatron/price/asphaltProfitList',
        method: 'get',
        params: query
    })
}

// 利润详情
export function profitDetail(query) {
    return request({
        url: `/material/metatron/price/detailsAsphaltProfitList`,
        method: 'get',
        params:query
    })
}

// 预焙阳极价格列表
export function yangPriceList(query) {
    return request({
        url: '/material/metatron/price/asphaltAnodePriceList',
        method: 'get',
        params: query
    })
}

// 预焙阳极价格详情
export function yangPriceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsAsphaltAnodePriceList`,
        method: 'get',
        params:query
    })
}

// 铝价格列表
export function lvPriceList(query) {
    return request({
        url: '/material/metatron/price/asphaltAluminiumPriceList',
        method: 'get',
        params: query
    })
}

// 铝价格详情
export function lvPriceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsAsphaltAluminiumPriceList`,
        method: 'get',
        params:query
    })
}

// 下游开工率列表
export function rateList(query) {
    return request({
        url: '/material/metatron/rate/asphaltDownRateList',
        method: 'get',
        params: query
    })
}

// 下游开工率详情
export function rateDetail(query) {
    return request({
        url: `/material/metatron/rate/detailsAsphaltDownRateList`,
        method: 'get',
        params:query
    })
}

// 下游产量列表(资讯)
export function downYieldXinList(query) {
    return request({
        url: '/material/industry/asphaltDownYieldList',
        method: 'get',
        params: query
    })
}

// 下游产量详情（资讯）
export function downYieldXinDetail(id) {
    return request({
        url: `/material/industry/asphaltDownYield/${id}`,
        method: 'get',
    })
}

// 下游产量列表
export function downYieldList(query) {
    return request({
        url: '/material/metatron/yield/asphaltDownYieldList',
        method: 'get',
        params: query
    })
}

// 下游产量详情
export function downYieldDetail(query) {
    return request({
        url: `/material/metatron/yield/detailsAsphaltDownYieldList`,
        method: 'get',
        params:query
    })
}

// 下游进出口量列表
export function downExitList(query) {
    return request({
        url: '/material/industry/asphaltDownExitList',
        method: 'get',
        params: query
    })
}

// 下游进出口量详情
export function downExitDetail(id) {
    return request({
        url: `/material/industry/asphaltDownExit/${id}`,
        method: 'get',
    })
}

// 下游库存列表
export function downStockList(query) {
    return request({
        url: '/material/metatron/stock/asphaltDownStockList',
        method: 'get',
        params: query
    })
}

// 下游库存详情
export function downStockDetail(query) {
    return request({
        url: `/material/metatron/stock/detailsAsphaltDownStockList`,
        method: 'get',
        params:query
    })
}

// 下游进利润列表
export function downProfitList(query) {
    return request({
        url: '/material/metatron/price/asphaltDownProfitList',
        method: 'get',
        params: query
    })
}

// 下游进利润详情
export function downProfitDetail(query) {
    return request({
        url: `/material/metatron/price/detailsAsphaltDownProfitOneList`,
        method: 'get',
        params:query
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/material/report/asphaltList',
        method: 'get',
        params: query
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/material/report/technicalAsphaltInfo/${id}`,
        method: 'get',
    })
}

// 折线图
export function priceDetailData(query) {
    return request({
        url: `/material/metatron/detail/lineChart`,
        method: 'get',
        params:query
    })
}